import { render } from "./info-header.vue?vue&type=template&id=e78db936&scoped=true"
import script from "./info-header.vue?vue&type=script&lang=js"
export * from "./info-header.vue?vue&type=script&lang=js"

import "./info-header.vue?vue&type=style&index=0&id=e78db936&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78db936"]])

export default __exports__